<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
         <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="ctrPublicId" v-model="searchParams.ctrPublicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 10rem"
                                :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="ctrPublicId">관할행정</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="areaTag" v-model="searchParams.areaTag" :options ="cboAreaTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em"/>
                        <label for="areaTag">영역분류</label>
                    </div>
                    <div class="p-field-0 p-float-label m-2">
                        <div class="p-inputgroup">
                            <InputText id="calcYm" v-model.trim="searchParams.calcYm" type="text" style="width:8rem" @keydown.enter="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                            <label for="calcYm">평가년도</label>
                            <Button icon="pi pi-search" class="p-button-search" @click="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                        </div>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="calcCnt" type="text" style="width:8rem" v-model="searchParams.calcCnt" disabled/>
                        <label for="calcCnt">평가차수</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>평가시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>평가종료일자</label>
                    </div>
                </div> 
            </template>

        </Toolbar>
        <DataTable id="dt" ref="dt" :value="dataList" showGridlines
            scrollable scrollHeight="78vh"
            rowIndexVar="rowIndex" :loading="loading"
            class="p-datatable-sm" responsiveLayout="scroll">
            <ColumnGroup type="header">
                <Row>
                    <Column field="ctrPublicId" header="관할행정" :sortable="true" :rowspan="2"></Column>
                    <Column field="corpNm" header="업체명" :sortable="true" :rowspan="2"></Column>
                    <Column field="areaTagNm" header="영역" :sortable="true" :rowspan="2"></Column>
                    <Column header="흑자운행노선" :colspan="2"></Column>
                    <Column header="적자운행노선" :colspan="2"></Column>
                    <Column header="합계" :colspan="2"></Column>
                </Row>
                <Row>
                    <Column field="pAmtCnt" header="수" :sortable="true"></Column>
                    <Column field="pAmt" header="금액" :sortable="true"></Column> 
                    <Column field="mAmtCnt" header="수" :sortable="true"></Column>
                    <Column field="mAmt" header="금액" :sortable="true"></Column>
                    <Column field="sumCnt" header="수" :sortable="true"></Column>
                    <Column field="sumAnt" header="금액" :sortable="true"></Column>
                </ROW>
            </ColumnGroup>
                <Column field="ctrPublicId" header="관할행정" :sortable="true" exportFooter=" " footer-style="border-width: 1px 0px">
                    <template #body="{data}">
                        {{(publicCodes.find(e=>e.code == data.ctrPublicId)||{codeNm:""})['codeNm']}}
                    </template>
                </Column>
                <Column field="corpNm" header="업체명" :sortable="true" exportFooter=" " footer-style="border-width: 1px 0px; text-align: right;"></Column>
                <Column field="areaTagNm" header="영역" :sortable="true" exportFooter=" " footer="합계 : " footer-style="justify-content: flex-end; text-align: right;"></Column>
                <Column field="pamtCnt" header="수" :sortable="true" exportFooter=" " :footer="getpamtCnt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
                <Column field="pamt" header="금액" :sortable="true" exportFooter=" " :footer="getpamt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
                <Column field="mamtCnt" header="수" :sortable="true" exportFooter=" " :footer="getmamtCnt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
                <Column field="mamt" header="금액" :sortable="true" exportFooter=" " :footer="getmamt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
                <Column field="sumCnt" header="수" :sortable="true" exportFooter=" " :footer="getsumCnt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
                <Column field="sumAnt" header="금액" :sortable="true" exportFooter=" " :footer="getsumAnt"  footer-style="justify-content: flex-end; text-align: right;">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                </Column>
        </DataTable>
    </div>
    <CodeHelpDialog v-model:search="searchCodeHelp" v-model:selection="selectedCodeHelp" v-model:visible="isCodeHelpDialog" @onComplete="codeHelpComplete" />
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import CodeService from '@/service/cm/CodeService';
import MA501070Service from '@/service/ma/MA501070Service';
import JsUtils from '@/utilities/JsUtils';
import CodeHelpDialog from '@/components/CodeHelpDialog';
import { useToast } from 'primevue/usetoast';
import { computed } from 'vue';


export default {
    components: {
        'CodeHelpDialog': CodeHelpDialog,
    },
    setup() { 
        
        onMounted(() => {
            searchParams.compSeq = 1;

            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                    searchParams.ctrPublicId = user.publicId;  // 업체소재지
                    isCustUser.value = true;
                }
            }

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드
            codeService.getCodeList({ compSeq:1, upCode:'_run_tag'}).then(data=> cboRunTags.value = data);  // 노선명분류 코드
            // codeService.getCodeList({ compSeq:1, upCode:'_carno_nm'}).then(data=> cborouteNms.value = data);  // 차량번호 코드
        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const ma501070Service = new MA501070Service();
        const searchParams = reactive({ctrPublicId:null,fromDate: null, toDate: null});
        const dataList = ref([]);
        const publicCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const cboRunTags = ref([]);
        const cboRouteNms = ref([]);
        const toast = useToast();
        const loading = ref(false);

        const yns = ref([
            {codeNm: '사용', code: 1},
            {codeNm: '중지', code: 2}
        ])

       // 코드도움 Dialog
        const isCodeHelpDialog = ref(false);    // 코드도움다이얼로그 표시 여부
        const searchCodeHelp = reactive({compSeq:1, helpId:"_calc_cnt", conds:[{'calcYm':null}]});  // 코드도움 검색조건
        const selectedCodeHelp = ref({});       // 코드도움 다이얼로그 검색결과에서 선택된 항목

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchMA501070();
                    break;
                default:
            }
        }

       const btnDialog = (_act, _str) => {
            switch(_act) {
                case 'CodeHelpDialog':
                    // CodeHelpDialog는 공통으로 사용하기 때문에 특정한 Id( ex: calcYm)로 넘기지말고 배열에 담아 넘겨야 한다
                    // 또한, CodeHelpDialog에 넘기는 검색조건도 하나 이상일 수 있다
                    searchCodeHelp.conds[0] = _str;  

                    // CodeHelpDialog를 표시한다
                    isCodeHelpDialog.value = true;

                    // 기존 검색조건을 초기화한다
                    searchParams.calcCnt = null;
                    searchParams.fromDate = null;
                    searchParams.toDate = null;
                    break;
                default:
                    break;
            }
        }

        const searchMA501070 = () => {
            // searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            // searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);
            if(!JsUtils.checkUndefineColumns(searchParams, ["calcYm","calcCnt"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'평가년도는 필수입력 항목입니다', life:2000});
                return;
            }

            ma501070Service.getList(searchParams).then(data => {   
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});               
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };
        
        const codeHelpComplete = () => {
             //alert('selectedCodeHelp.value = ' + JSON.stringify(selectedCodeHelp.value));
            searchParams.calcYm = selectedCodeHelp.value.CALC_YM;
            searchParams.calcCnt = selectedCodeHelp.value.CALC_CNT;
            searchParams.fromDate = selectedCodeHelp.value.CALC_FR_YMD;
            searchParams.toDate = selectedCodeHelp.value.CALC_TO_YMD;
            //selectedCodeHelp.value = {};
        }
        
        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        const getpamtCnt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.pamtCnt);
            }
            return formatToPrice(total);
        });

        const getpamt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.pamt);
            }
            return formatToPrice(total);
        });

        const getmamtCnt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.mamtCnt);
            }
            return formatToPrice(total);
        });

        const getmamt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.mamt);
            }
            return formatToPrice(total);
        });

        const getsumCnt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.sumCnt);
            }
            return formatToPrice(total);
        });

        const getsumAnt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.sumAnt);
            }
            return formatToPrice(total);
        });

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, cboRunTags,cboRouteNms,btnDialog,isCustUser, loading,
            yns, formatToPrice,
            isCodeHelpDialog, searchCodeHelp, selectedCodeHelp, codeHelpComplete,
            btnAct, downloadExcel, exportCSV, getpamtCnt, getpamt, getmamtCnt, getmamt, getsumCnt, getsumAnt
        }

    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
